export default __webpack_public_path__ + "static/Smiley-f5ef681825b2ec63be5ed72eee85345e.jpg";